var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',{staticClass:"folders-name text-secondary"},[_c('i',{staticClass:"fas fa-folder text-warning treeview-item-icon pr-1"}),_vm._v(_vm._s(_vm.names.name)+"\n    "),(_vm.names.child && _vm.names.child.name)?_c('FoldersName',{attrs:{"names":_vm.names.child}}):_vm._e()],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91be6cd4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/operational/documents/components/foldersname/foldersname.vue
// module id = null
// module chunks = 